export default "__VITE_ASSET__CGhR0AIk__"